import styled from "styled-components";
export const NewInventoryPageWrapper = styled.div<{
    alignItems?: "center" | "flex-start" | "flex-end";
}>`
    display: flex;
    flex-direction: column;
    justify-content: ${props => props.alignItems || "center"};
    align-items: ${props => props.alignItems || "center"};
    gap: 30px;
`;

export const FormWrapper = styled.div<{ alignItems?: "center" | "flex-start" | "flex-end" }>`
    display: flex;
    flex-direction: column;
    align-items: ${props => props.alignItems || "center"};
    gap: 10px;
    width: 85%;
`;
export const CompanyNameWrapper = styled.div<{ alignItems?: "center" | "flex-start" | "flex-end" }>`
    display: flex;
    flex-direction: column;
    align-items: ${props => props.alignItems || "center"};
    gap: 10px;
    width: 100%;
    margin-bottom: 18px;
    margin-top: 40px;
`;

export const Form = styled.form`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 10px;
`;

export const ActionButtons = styled.div`
    display: flex;
    width: 95%;
    gap: 2rem;
    position: fixed;
    bottom: 2rem;
`;
